/** Where a hypothesis lives in the app (`/cases/:caseId/hypotheses/:hypothesisId`). */
export const hypothesisPath = (caseId: string, hypothesisId: string) =>
  `/cases/${caseId}/hypotheses/${hypothesisId}`

/** The legacy research detail an old `/hypotheses/:id` link meant (a `case_hypotheses` row). */
export const researchPath = (caseId: string, researchId: string) =>
  `/cases/${caseId}/search/${researchId}`

/** A saved investigation's page. */
export const investigationPath = (caseId: string, investigationId: string) =>
  `/cases/${caseId}/investigations/${investigationId}`
